import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  pagNav: {
    defaultMessage: 'Page Navigation',
  },
  previousPage: {
    defaultMessage: 'Go to previous page',
  },
  previous: {
    defaultMessage: 'Previous',
  },
  nextPage: {
    defaultMessage: 'Go to next page',
  },
  next: {
    defaultMessage: 'Next',
  },
  goToPage: {
    defaultMessage: 'Go to page {pageNumber}',
  },
});
